import type { IMultiplacerModuleKey } from "@multiconsult-group/multiplacer-core";
import { DesignRole } from "@multiconsult-group/multiplacer-core";
import type { IconType } from "react-icons";
import {
  FaClipboardCheck,
  FaCloudSun,
  FaHashtag,
  FaProjectDiagram,
  FaSearch,
  FaUser,
  FaUsersCog,
  FaUserTie,
} from "react-icons/fa";

export const MODULE_ICON_BY_KEY: Record<IMultiplacerModuleKey, IconType> = {
  CEILING: FaCloudSun,
  RFP: FaClipboardCheck,
  EXPLORE: FaSearch,
  ROOM_NUMBERING: FaHashtag,
};

export const ROLE_ICON_BY_KEY: Record<DesignRole, IconType> = {
  [DesignRole.BIM_SAMORDNER]: FaProjectDiagram,
  [DesignRole.PROSJEKTERANDE]: FaUser,
  [DesignRole.DISCIPLINELEDER]: FaUsersCog,
  [DesignRole.PROSJEKTLEDER]: FaUserTie,
};
